export function createStatusCodeErrorMessage(statusCode: number) {
    const url = window.location.href;
    const variationId = getVariationIdFromUrl(url);
    const productId = getProductIdFromUrl(url);
    return `ui-aggregator-status-code: ${statusCode} on productId: ${productId} from variationId ${variationId}, url: ${url}`;
}

function getVariationIdFromUrl(url: string) {
    return url.split('/#variationId=')[1];
}

function getProductIdFromUrl(url: string) {
    const productUrl = url.split('/#variationId=')[0];
    const productUrlSplit = productUrl.split('-');
    return productUrlSplit[productUrlSplit.length - 1];
}

/**
 * This function will help users trying to change a dimension on an old browser tab.
 * Once the JS is fully loaded, the OTP session and token will be updated in the local storage.
 * Consequently, the user will not encounter a 'Guru Meditation' page and can continue using the website.
 */
export function redirectToPreviousVariation(variationId: string): void {
    const url = window.location.href;
    const productUrl = url.split('/#variationId')[0];
    if (productUrl) {
        window.location.href = `${productUrl}/#variationId=${variationId}`;
        window.location.reload();
    }
}
